const statusCodes = {
  FIL: 'Filed',
  HCS: 'House Committee Substitute',
  HPA: 'House Proposed Amendment',
  HFA: 'House Floor Amendment',
  ENG: 'Engrossed',
  SCS: 'Senate Committee Substitute',
  SPA: 'Senate Proposed Amendment',
  SFA: 'Senate Floor Amendment',
  ENR: 'Enrolled',
  CCR: 'Conference Committee Report',
  CC2: 'Conference Committee Report #2',
  CC3: 'Conference Committee Report #3',
  CC4: 'Conference Committee Report #4',
  CC5: 'Conference Committee Report #5',
  VET: "Governor's Veto Message",
};

export default statusCodes;
